export const authStatusOptionsForFinalWorklist = [
  {
    bgColor: "#F5F5F5",
    id: "Required",
    priority: 1,
    text: "Required",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFFCD6",
    id: "Pending",
    priority: 2,
    text: "Pending",
    textColor: "#665D00",
  },
  {
    bgColor: "#E6F3F0",
    id: "Auth by RISA",
    priority: 3,
    text: "Auth by RISA",
    textColor: "#005D49",
  },
  {
    bgColor: "#F8FFEB",
    id: "Auth on file",
    priority: 4,
    text: "Auth on File",
    textColor: "#537A00",
  },
  {
    bgColor: "#EBFFFF",
    id: "NAR",
    priority: 5,
    text: "NAR",
    textColor: "#007A7A",
  },
  {
    bgColor: "#FFEBFB",
    id: "Authorized by onshore team",
    priority: 6,
    text: "Authorized by Onshore Team",
    textColor: "#C20097",
  },
  {
    bgColor: "#FFE8E8",
    id: "Existing denial",
    priority: 7,
    text: "Existing Denial",
    textColor: "#CC0300",
  },
  {
    bgColor: "#FFE8E8",
    id: "Denial after query",
    priority: 8,
    text: "Denial After Query",
    textColor: "#CC0300",
  },
  {
    bgColor: "#FFE8E8",
    id: "Already auth denied",
    priority: 9,
    text: "Already Auth Denied",
    textColor: "#CC0300",
  },
  {
    bgColor: "#FFE8E8",
    id: "Denial by RISA",
    priority: 9,
    text: "Denial by RISA",
    textColor: "#CC0300",
  },
  {
    bgColor: "#F6E5FF",
    id: "Query",
    priority: 10,
    text: "Query",
    textColor: "#4B00CC",
  },
  {
    bgColor: "#f5f5f5",
    id: "Worked by onshore team",
    priority: 11,
    text: "Worked by Onshore Team",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Drug removed",
    priority: 12,
    text: "Drug Removed",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Drug changed",
    priority: 13,
    text: "Drug Changed",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Insurance changed",
    priority: 14,
    text: "Insurance Changed",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#f3f4f6",
    id: "Treatment plan changed",
    priority: 15,
    text: "Treatment Plan Changed",
    textColor: "#374151",
  },
  {
    bgColor: "#f3f4f6",
    id: "DOS changed",
    priority: 16,
    text: "DOS Changed",
    textColor: "#374151",
  },
  {
    bgColor: "#FFF3E0",
    id: "Auth required",
    priority: 17,
    text: "Auth Required",
    textColor: "#C24400",
  },
  {
    bgColor: "#fef3c7",
    id: "Gold bag",
    priority: 18,
    text: "Gold Bag",
    textColor: "#92400e",
  },
  {
    bgColor: "#FFF3E0",
    id: "Hold",
    priority: 19,
    text: "Hold",
    textColor: "#C24400",
  },
  {
    bgColor: "#FFE8E8",
    id: "Oral drug",
    priority: 20,
    text: "Oral Drug",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Pharmacy drug",
    priority: 21,
    text: "Pharmacy Drug",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Free drug",
    priority: 22,
    text: "Free Drug",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "On study patient",
    priority: 23,
    text: "On Study Patient",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Not to work/Oral drug",
    priority: 24,
    text: "Not to Work/Oral Drug",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Study Patient",
    priority: 25,
    text: "Study Patient",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFEBFB",
    id: "POD",
    priority: 26,
    text: "POD",
    textColor: "#C20097",
  },
  {
    bgColor: "#FFE8E8",
    id: "Not to work/Stat case",
    priority: 27,
    text: "Not to Work/Stat Case",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Not to work",
    priority: 28,
    text: "Not to Work",
    textColor: "#0F0F0F",
  },
  {
    bgColor: "#FFE8E8",
    id: "Worked by Fedora team",
    priority: 29,
    text: "Worked by Fedora Team",
    textColor: "#0F0F0F",
  },
];
